export default __webpack_public_path__ + "static/media/circleOnTopLeftLight.17906c62.svg";